export const isAnyVisibleChildren = (children: React.ReactNode): boolean => {
  if (Array.isArray(children)) {
    return children.some((child) => isAnyVisibleChildren(child));
  }
  return Boolean(children);
};
